import { render } from "./PageTitle.vue?vue&type=template&id=af1cd96e"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import AddButton from "@/components/AddButton.vue";
script.components = Object.assign({}, { AddButton }, script.components);